<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-form-item name="nama_periode" label="Nama Periode">
            <a-input v-model:value="formState.nama_periode" placeholder="Masukkan Nama Periode" />
          </a-form-item>

          <a-form-item name="tanggal_mulai_pengajuan" label="Tanggal Mulai Pengajuan" style="margin-bottom: 0;">
            <a-date-picker
              v-model:value="formState.tanggal_mulai_pengajuan"
              placeholder="Pilih Tanggal"
              format="DD-MM-YYYY"
              valueFormat="YYYY-MM-DD"
              :showTime="false"
              :show-now="false"
              style="width: 100%"
            />
          </a-form-item>

          <a-form-item name="tanggal_selesai_pengajuan" label="Tanggal Selesai Pengajuan" style="margin-bottom: 0;">
            <a-date-picker
              v-model:value="formState.tanggal_selesai_pengajuan"
              placeholder="Pilih Tanggal"
              format="DD-MM-YYYY"
              valueFormat="YYYY-MM-DD"
              :showTime="false"
              :show-now="false"
              style="width: 100%"
            />
          </a-form-item>

          <a-form-item name="tanggal_mulai_approval" label="Tanggal Mulai Approval" style="margin-bottom: 0;">
            <a-date-picker
              v-model:value="formState.tanggal_mulai_approval"
              placeholder="Pilih Tanggal"
              format="DD-MM-YYYY"
              valueFormat="YYYY-MM-DD"
              :showTime="false"
              :show-now="false"
              style="width: 100%"
            />
          </a-form-item>

          <a-form-item name="tanggal_selesai_approval" label="Tanggal Selesai Approval" style="margin-bottom: 0;">
            <a-date-picker
              v-model:value="formState.tanggal_selesai_approval"
              placeholder="Pilih Tanggal"
              format="DD-MM-YYYY"
              valueFormat="YYYY-MM-DD"
              :showTime="false"
              :show-now="false"
              style="width: 100%"
            />
          </a-form-item>

          <a-form-item name="is_active" label="Status">
            <div style="display: flex; align-items: center; gap: 8px;">
              <a-switch v-model:checked="formState.is_active" />
              <span>{{ formState.is_active ? 'Aktif' : 'Non Aktif' }}</span>
            </div>
          </a-form-item>

          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link to="/assessment/master/periode">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../../components/crud/style';
import { Main } from '../../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const PeriodeForm = {
  name: 'PeriodeForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);

    const formatDateFromUTC = dateString => {
      if (!dateString) return '';
      return dayjs(dateString)
        .tz('Asia/Jakarta')
        .format('YYYY-MM-DD');
    };

    const formState = reactive({
      nama_periode: '',
      tanggal_mulai_pengajuan: '',
      tanggal_selesai_pengajuan: '',
      tanggal_mulai_approval: '',
      tanggal_selesai_approval: '',
      is_active: true,
    });

    const options = reactive({
      direktorat: [],
    });

    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const handleSubmit = values => {
      const formData = {
        ...values,
        tanggal_mulai_pengajuan: values.tanggal_mulai_pengajuan,
        tanggal_selesai_pengajuan: values.tanggal_selesai_pengajuan,
        tanggal_mulai_approval: values.tanggal_mulai_approval,
        tanggal_selesai_approval: values.tanggal_selesai_approval,
      };

      if (props.mode === 'Tambah') {
        dispatch('axiosCrudSubmitData', {
          url: 'periode-assessment',
          data: formData,
        });
      } else if (props.mode === 'Ubah') {
        dispatch('axiosDataUpdate', {
          id: params.id,
          url: 'periode-assessment',
          data: formData,
        });
      }
    };

    const rules = {
      nama_periode: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
      tanggal_mulai_pengajuan: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
      tanggal_selesai_pengajuan: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
        {
          validator: (rule, value) => {
            if (value && formState.tanggal_mulai_pengajuan && value < formState.tanggal_mulai_pengajuan) {
              return Promise.reject('Tanggal Selesai Pengajuan tidak boleh kurang dari Tanggal Mulai Pengajuan');
            }
            return Promise.resolve();
          },
          trigger: 'change',
        },
      ],
      tanggal_mulai_approval: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
        {
          validator: (rule, value) => {
            if (value && formState.tanggal_mulai_approval && value < formState.tanggal_selesai_pengajuan) {
              return Promise.reject('Tanggal Mulai Approval tidak boleh kurang dari Tanggal Selesai Pengajuan');
            }
            return Promise.resolve();
          },
          trigger: 'change',
        },
      ],
      tanggal_selesai_approval: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
        {
          validator: (rule, value) => {
            if (value && formState.tanggal_mulai_approval && value < formState.tanggal_mulai_approval) {
              return Promise.reject('Tanggal Selesai Approval tidak boleh kurang dari Tanggal Mulai Approval');
            }
            return Promise.resolve();
          },
          trigger: 'change',
        },
      ],
    };

    const filterSelect = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    onMounted(() => {
      dispatch('axiosCrudGetData', 'options-direktorat').then(() => {
        options.direktorat = crud.value;
      });

      if (props.mode === 'Ubah' && params.id) {
        dispatch('axiosSingleDataGet', { url: 'periode-assessment', id: params.id }).then(() => {
          const data = crud.value;
          formState.nama_periode = data.nama_periode;
          formState.tanggal_mulai_pengajuan = formatDateFromUTC(data.tanggal_mulai_pengajuan);
          formState.tanggal_selesai_pengajuan = formatDateFromUTC(data.tanggal_selesai_pengajuan);
          formState.tanggal_mulai_approval = formatDateFromUTC(data.tanggal_mulai_approval);
          formState.tanggal_selesai_approval = formatDateFromUTC(data.tanggal_selesai_approval);
          formState.is_active = data.is_active;
        });
      }
    });

    return {
      formState,
      labelCol,
      wrapperCol,
      handleSubmit,
      isLoading,
      rules,
      filterSelect,
      options,
    };
  },
};

export default PeriodeForm;
</script>
